/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import {
  type AnimatedIllustrativeBaseIconProps,
  AnimatedIllustrativeIcon,
} from "../animated-illustrative-icon";
import animationData from "../assets/json/analysis-done-offblack-animated.json";

export const IllustrativeIconAnalysisDoneOffblackAnimated = (props: AnimatedIllustrativeBaseIconProps) => (
  <AnimatedIllustrativeIcon {...props} json={animationData} />
);

IllustrativeIconAnalysisDoneOffblackAnimated.displayName = "IllustrativeIconAnalysisDoneOffblackAnimated";
